import React, {useState} from "react"
import GenericModal from "@irati/ui/src/GenericModal"
import {GroupCelebration} from "@irati/types"
import RecognitionService from "@irati/recognition/services/Recognition"
import {injectIntl, InjectIntlProps} from "@irati/utils/lang/injectIntl"
import {Body, H2} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"

interface Props extends InjectIntlProps {
  show: boolean
  groupCelebration: GroupCelebration
  onClose: () => void
  onDone: () => void
}
const DeleteGroupCelebration = (props: Props) => {
  const {show, formatMessage, groupCelebration, onClose, onDone} = props
  const [promise, setPromise] = useState<Promise<void>>()

  const deleteGroupCelebration = () => {
    const deletePromise = RecognitionService.deleteGroupCelebration(groupCelebration).then(() => {
      onDone()
    })
    setPromise(deletePromise)
  }
  return (
    <GenericModal
      show={show}
      load={promise}
      proceedButtonText={formatMessage({id: "platform.button.delete"})}
      onConfirm={deleteGroupCelebration}
      onHide={onClose}
      onExited={onClose}>
      <H2>
        <FormattedMessage id="recognition.groupCelebration.deletePopup.header" />
      </H2>
      <Body marginBottom={3} marginTop={2}>
        <FormattedMessage id="recognition.groupCelebration.deletePopup.body" />
      </Body>
    </GenericModal>
  )
}

export default injectIntl(DeleteGroupCelebration)
